/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Custom theme scripts
 *
 * Keep page-specific code inside its own init function.
 * Add new page types by checking the body template class below,
 * then calling a matching init function.
 */
document.addEventListener('DOMContentLoaded', () => {
  const page = document.body.classList;

  if (page.contains('template-product')) initProductPage();
});

/**
 * Product page scripts
 *
 * Refreshes Easify's total price when a Shopify variant changes.
 * Warehouse triggers the "variant:changed" event on product pages,
 * which is cleaner than listening for every select/input change.
 */
function initProductPage() {
  const refreshEasifyPrice = () => {
    setTimeout(() => {
      const easifyOptionInputs = document.querySelectorAll('.easify-option input, .easify-option select, .easify-option textarea, [name^="properties"]');

      easifyOptionInputs.forEach((input) => {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }, 150);
  };

  document.addEventListener('variant:changed', function (event) {
    refreshEasifyPrice();
  });
}
